import {IAccVoucherActionTypes} from "../../action-types/category/IAccVoucherActions";
import {IAccVoucherReducer} from "../../reducer-model/category/IAccVoucherReducer";
import {eReducerStatusBase} from "../../reducer-model/eReducerStatusBase";

const iniState: IAccVoucherReducer = {
    status: eReducerStatusBase.is_not_initialization,
    vouchers: [],
    idSelections: [],
};
export const voucherReducer = (
    state: IAccVoucherReducer = iniState,
    action: IAccVoucherActionTypes
): IAccVoucherReducer => {
    switch (action.type) {
        case "VOUCHER_LOAD_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
                idSelections: [],
            };
        case "VOUCHER_LOAD_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                vouchers: action.payload,
            };
        case "VOUCHER_LOAD_ERRR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "VOUCHER_SAVE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_saving,
            };
        case "VOUCHER_SAVE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
                isShowEditModal: false,
            };
        case "VOUCHER_SAVE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "VOUCHER_DELETE_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "VOUCHER_DELETE_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "VOUCHER_DELETE_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        case "VOUCHER_SHOW_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: true,
                voucherEditing: action.payload,
            };
        case "VOUCHER_CLOSE_EDIT_MODAL":
            return {
                ...state,
                isShowEditModal: false,
                voucherEditing: undefined,
            };
        case "VOUCHER_SELECTED_ID":
            return {
                ...state,
                idSelections: action.payload,
            };
        case "VOUCHER_DELETE_MANY_START":
            return {
                ...state,
                status: eReducerStatusBase.is_deleting,
            };
        case "VOUCHER_DELETE_MANY_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_need_reload,
            };
        case "VOUCHER_DELETE_MANY_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            };
        default:
            return state;
    }
};
